(function () {
  if (customElements.get('owa-cart-share')) {
    return;
  }

  function getRoute(key, fallback) {
    if (window.routes && window.routes[key]) return window.routes[key];
    if (window.theme && window.theme.routes && window.theme.routes[key]) return window.theme.routes[key];
    return fallback;
  }

  function getCartJsonUrl() {
    const cartPath = getRoute('cart_url', '/cart').replace(/\/$/, '');
    return `${cartPath}.js`;
  }

  class OwaCartShare extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('[data-owa-cart-share-button]');
      this.message = this.querySelector('[data-owa-cart-share-message]');
      this.shareTitle = this.dataset.shareTitle || document.title;
      this.shareText = this.dataset.shareText || '';
      this.shareToast = this.dataset.shareToast || 'Link naar winkelmand gekopieerd';
      this.sharePrompt = this.dataset.sharePrompt || 'Kopieer deze link naar je winkelmand:';
      this.shippingProtectionVariantId = String(this.dataset.shippingProtectionVariantId || '');
      this.messageTimer = null;
      this.handleClick = this.handleClick.bind(this);
    }

    connectedCallback() {
      if (!this.button || this.dataset.owaCartShareBound === 'true') return;
      this.dataset.owaCartShareBound = 'true';
      this.button.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      if (!this.button) return;
      this.button.removeEventListener('click', this.handleClick);
      delete this.dataset.owaCartShareBound;
    }

    async handleClick(event) {
      event.preventDefault();
      if (!this.button || this.button.disabled) return;

      const originalLabel = this.button.querySelector('span:last-child')?.textContent || '';

      this.button.disabled = true;

      try {
        const shareUrl = await this.buildShareUrl();

        if (navigator.share) {
          try {
            await navigator.share({
              url: shareUrl,
            });
            return;
          } catch (error) {
            if (error && error.name === 'AbortError') {
              return;
            }
          }
        }

        await this.copyOrPrompt(shareUrl);
      } catch (error) {
        console.error('Cart share failed', error);
        this.promptForCopy(window.location.href);
      } finally {
        this.button.disabled = false;
        const label = this.button.querySelector('span:last-child');
        if (label && originalLabel) {
          label.textContent = originalLabel;
        }
      }
    }

    async buildShareUrl() {
      const response = await fetch(getCartJsonUrl(), {
        headers: {
          Accept: 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('Cart fetch failed');
      }

      const cart = await response.json();
      const variantQuantities = new Map();

      (cart.items || []).forEach((item) => {
        const variantId = String(item.variant_id || item.id || '');
        const quantity = Number(item.quantity || 0);

        if (!variantId || quantity <= 0) return;
        if (this.shippingProtectionVariantId && variantId === this.shippingProtectionVariantId) return;

        variantQuantities.set(variantId, (variantQuantities.get(variantId) || 0) + quantity);
      });

      const permalinkItems = Array.from(variantQuantities.entries())
        .map(([variantId, quantity]) => `${variantId}:${quantity}`)
        .join(',');

      const cartUrl = new URL(getRoute('cart_url', '/cart'), window.location.origin);

      if (!permalinkItems) {
        return cartUrl.toString();
      }

      return `${cartUrl.origin}${cartUrl.pathname.replace(/\/$/, '')}/${permalinkItems}`;
    }

    async copyOrPrompt(shareUrl) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        try {
          await navigator.clipboard.writeText(shareUrl);
          this.showMessage();
          return;
        } catch (error) {
          console.warn('Clipboard write failed, falling back to prompt', error);
        }
      }

      this.promptForCopy(shareUrl);
    }

    promptForCopy(shareUrl) {
      window.prompt(this.sharePrompt, shareUrl);
    }

    showMessage() {
      if (!this.message) return;

      this.message.textContent = this.shareToast;
      this.message.classList.add('is-visible');

      if (this.messageTimer) {
        window.clearTimeout(this.messageTimer);
      }

      this.messageTimer = window.setTimeout(() => {
        this.message.classList.remove('is-visible');
      }, 2200);
    }
  }

  customElements.define('owa-cart-share', OwaCartShare);
})();
